/* Woodbury Atelier — theme interactions
   Overlays, scroll reveal, AJAX cart, variant picker, facets, accordions. */
(function () {
  'use strict';

  const header = document.querySelector('[data-header]');
  const veil = document.querySelector('[data-veil]');
  const searchOverlay = document.querySelector('[data-search]');
  const cartDrawer = document.querySelector('[data-cart]');
  const mobileNav = document.querySelector('[data-mobile]');
  const overlayClose = document.querySelector('[data-overlay-close]');
  const toast = document.querySelector('[data-toast]');

  /* ---------- Header ---------- */
  if (header) {
    // Transparent-over-dark-hero detection (page heroes set their own scheme)
    const firstSection = document.querySelector('#MainContent .shopify-section:first-child');
    if (firstSection && firstSection.querySelector('.hero, .page-hero--dark, .page-hero--espresso')) {
      header.classList.add('on-hero');
    }
    const onScroll = () => header.classList.toggle('is-solid', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Overlays ---------- */
  let open = null;
  function openOverlay(el, dark) {
    if (!el) return;
    closeOverlay();
    open = el;
    el.classList.add('is-open');
    if (el !== searchOverlay && el !== mobileNav && veil) veil.classList.add('is-open');
    if (overlayClose) {
      overlayClose.classList.add('is-open');
      overlayClose.classList.toggle('on-dark', !!dark);
    }
    document.body.style.overflow = 'hidden';
    if (el === searchOverlay) {
      const input = el.querySelector('input[type="search"]');
      if (input) setTimeout(() => input.focus(), 350);
    }
  }
  function closeOverlay() {
    if (!open) return;
    open.classList.remove('is-open');
    if (veil) veil.classList.remove('is-open');
    if (overlayClose) overlayClose.classList.remove('is-open');
    document.body.style.overflow = '';
    open = null;
  }
  document.querySelectorAll('[data-open-search]').forEach(b => b.addEventListener('click', () => openOverlay(searchOverlay)));
  document.querySelectorAll('[data-open-cart]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openOverlay(cartDrawer); }));
  document.querySelectorAll('[data-open-mobile]').forEach(b => b.addEventListener('click', () => openOverlay(mobileNav, true)));
  if (overlayClose) overlayClose.addEventListener('click', closeOverlay);
  if (veil) veil.addEventListener('click', closeOverlay);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeOverlay(); });

  /* ---------- Scroll reveal ---------- */
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-in'));
  }
  // Theme editor: re-run reveal for re-rendered sections
  document.addEventListener('shopify:section:load', e => {
    e.target.querySelectorAll('.reveal').forEach(el => el.classList.add('is-in'));
  });

  /* ---------- Accordions ---------- */
  document.addEventListener('click', e => {
    const head = e.target.closest('.acc-head');
    if (!head) return;
    const item = head.parentElement;
    const body = item.querySelector('.acc-body');
    const isOpen = item.classList.toggle('is-open');
    body.style.maxHeight = isOpen ? body.scrollHeight + 'px' : 0;
  });

  /* ---------- Toast ---------- */
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-on');
    setTimeout(() => toast.classList.remove('is-on'), 3600);
  }

  /* ---------- Cart helpers ---------- */
  const money = cents => {
    const fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2));
  };

  async function refreshCartUI(openDrawer) {
    // Re-render the header section (drawer + count) via the Section Rendering API
    try {
      const res = await fetch(`${window.location.pathname}?sections=header`);
      const data = await res.json();
      if (data.header) {
        const doc = new DOMParser().parseFromString(data.header, 'text/html');
        const newBody = doc.querySelector('[data-cart-body]');
        const curBody = document.querySelector('[data-cart-body]');
        if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;
        const newFootSub = doc.querySelector('[data-cart-subtotal]');
        const curFootSub = document.querySelector('[data-cart-subtotal]');
        if (newFootSub && curFootSub) { curFootSub.innerHTML = newFootSub.innerHTML; curFootSub.hidden = newFootSub.hidden; }
        const newCount = doc.querySelector('[data-cart-count]');
        document.querySelectorAll('[data-cart-count]').forEach(c => { if (newCount) c.textContent = newCount.textContent; });
      }
    } catch (err) { /* non-fatal */ }
    if (openDrawer && window.theme.cartDrawer) openOverlay(cartDrawer);
  }

  /* Add to cart (product form) */
  document.querySelectorAll('form[data-product-form]').forEach(formEl => {
    formEl.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = formEl.querySelector('[data-add-btn]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(window.theme.routes.cartAdd + '.js', {
          method: 'POST',
          body: new FormData(formEl),
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!res.ok) throw new Error();
        await refreshCartUI(true);
      } catch (err) {
        window.location.href = window.theme.routes.cart;
      } finally {
        if (btn) btn.removeAttribute('aria-busy');
      }
    });
  });

  /* Quantity change / remove (drawer + cart page) */
  document.addEventListener('click', async e => {
    const qbtn = e.target.closest('[data-qty-change]');
    if (!qbtn) return;
    e.preventDefault();
    qbtn.disabled = true;
    try {
      await fetch(window.theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: qbtn.dataset.qtyChange, quantity: parseInt(qbtn.dataset.qty, 10) })
      });
      if (document.querySelector('.cart-page-items')) {
        window.location.reload();
      } else {
        await refreshCartUI(false);
      }
    } catch (err) { showToast('Something went wrong.'); }
    qbtn.disabled = false;
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-product-info]').forEach(info => {
    const jsonEl = info.querySelector('[data-variant-json]');
    if (!jsonEl) return;
    const variants = JSON.parse(jsonEl.textContent);
    const rows = info.querySelectorAll('.size-row[data-option-index]');
    const idInput = info.querySelector('[data-variant-id]');
    const priceEl = info.querySelector('[data-price]');
    const addBtn = info.querySelector('[data-add-btn]');

    function selectedOptions() {
      return Array.from(rows).map(r => {
        const active = r.querySelector('.size-btn.is-active');
        return active ? active.dataset.optionValue : null;
      });
    }
    function syncVariant() {
      const opts = selectedOptions();
      const match = variants.find(v => v.options.every((o, i) => o === opts[i]));
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.childNodes[0].textContent = match.price + ' ';
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.dataset.label || addBtn.textContent : 'Sold Out';
      }
    }
    if (addBtn) addBtn.dataset.label = addBtn.textContent.trim();

    rows.forEach(row => {
      row.querySelectorAll('.size-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          row.querySelectorAll('.size-btn').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          syncVariant();
        });
      });
    });
  });

  /* ---------- Collection facets & sorting ---------- */
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.href;
    });
  }
  const filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', () => {
      const params = new URLSearchParams(new FormData(filterForm));
      window.location.href = `${window.location.pathname}?${params.toString()}`;
    });
  }

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(async el => {
    if (el.querySelector('.product-card')) return; // already rendered
    try {
      const res = await fetch(el.dataset.url);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        el.querySelectorAll('.reveal').forEach(r => r.classList.add('is-in'));
      }
    } catch (err) { /* non-fatal */ }
  });
})();
